<template>
  <div class="container-fluid h-100">
    <div class="container">
      <div class="row">
        <div class="col div-button">
          <button
            class="btn btn-success"
            data-toggle="modal"
            data-target="#modalNewBanner"
            @click="reset()"
          >
            Nueva publicación
          </button>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12">
          <div class="commentary">
            <span>Para cambiar el orden de las alianzas seleccione una y arrastrela a
              la posición deseada</span>
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                class="nav-item nav-link active"
                id="nav-home-tab"
                data-toggle="tab"
                href="#nav-home"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                >Activos</a
              >
              <a
                class="nav-item nav-link"
                id="nav-profile-tab"
                data-toggle="tab"
                href="#nav-profile"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false"
                >Historial</a
              >
              <a
                class="nav-item nav-link"
                id="nav-categoria-tab"
                data-toggle="tab"
                href="#nav-categoria"
                role="tab"
                aria-controls="nav-categoria"
                aria-selected="false"
                >Categorías</a
              >
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <!-- Alianzas activas -->
            <div
              class="tab-pane fade show active "
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div class="card p-3">
                <div class="card-body">
                  <div
                    class="row justify-content-end mb-3"
                    style="text-align: end;"
                  >
                    <div class="col-12 col-md-4 col-lg-3 col-xl-3 mb-2">
                      <button
                        :hidden="hidden.btn"
                        class="btn btn-danger btn-block"
                        @click="clean()"
                      >
                        Limpiar orden
                      </button>
                    </div>

                    <div class="col-12 col-md-4 col-xl-3 col-lg-3">
                      <button
                        :disabled="loading.order"
                        :hidden="hidden.btn"
                        class="btn btn-info btn-block"
                        @click="saveOrders()"
                      >
                        <template v-if="loading.order">
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Cargando...
                        </template>
                        <template v-else>Guardar orden </template>
                      </button>
                    </div>
                  </div>
                  <template v-if="loading.history">
                    <div class="d-flex justify-content-center">
                      <div
                        class="spinner-border text-danger"
                        style="width: 4em; height: 4rem;"
                        role="status"
                      ></div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="table-responsive">
                      <table class="table table-striped table-sm">
                        <caption class="visually-hidden">Listado de Alianzas</caption>
                        <thead>
                          <tr>
                            <th id="ab-1">Imagen</th>
                            <th id="ab-2">Nombre</th>
                            <!-- <th id="ab-3">Tamaño</th> -->
                            <th id="ab-13">Estado</th>
                          </tr>
                        </thead>
                        <tr v-for="(banner, index) of defectList" v-bind:key="banner.id">
                          <td style="width: 300px">
                            <img
                              class="img-banner"
                              :src="banner.url"
                              :alt="banner.name"
                            />
                          </td>
                          <td>{{ banner.name }}</td>
                          <!-- <td>{{ banner.sizes != null ? banner.sizes.description : ''}}</td> -->
                          <td>
                            <label
                              v-if="banner.status_id == 1"
                              style="color: #dc3545"
                            >
                              {{ banner.status.name }}
                            </label>
                            <label v-else style="color: gray">
                              {{ banner.status.name }}
                            </label>
                          </td>
                        </tr>
                        <draggable v-model="bannerList" tag="tbody">
                          <tr
                            v-for="(banner, index) of bannerList"
                            :key="index"
                          >
                            <td style="width: 300px"
                            >
                              <img
                                class="img-banner"
                                :src="banner.url"
                                :alt="banner.name"
                              />
                            </td>
                            <td>{{ banner.name }}</td>
                            <!-- <td>{{ banner.sizes != null ? banner.sizes.description : ''}}</td> -->
                            <td>
                              <label
                                v-if="banner.status_id == 1"
                                style="color: #dc3545"
                              >
                                {{ banner.status.name }}
                              </label>
                              <label v-else style="color: gray">
                                {{ banner.status.name }}
                              </label>
                            </td>
                          </tr>
                        </draggable>
                      </table>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <!-- Historial de alianzas -->
            <div
              class="tab-pane fade"
              id="nav-profile"
              role="tabpanel"
              aria-labelledby="nav-profile-tab"
            >
              <div class="card ">
                <div class="card-body">
                  <template v-if="loading.history">
                    <div class="d-flex justify-content-center">
                      <div
                        class="spinner-border text-danger"
                        style="width: 4em; height: 4rem;"
                        role="status"
                      ></div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="table-responsive">
                      <table class="table table-striped table-sm">
                        <caption class="visually-hidden">Listado de Alianzas</caption>
                        <thead>
                          <tr>
                            <th id="ab-4">Imagen</th>
                            <th id="ab-5">Nombre</th>
                            <!-- <th id="ab-15">Tamaño</th> -->
                            <th id="ab-7">Redirección</th>
                            <th id="ab-8">Estado</th>
                            <th id="ab-9">Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(banner, index) of history" v-bind:key="banner.id" v-if="banner.size == 5 && banner.description == null">
                            <td style="width: 300px"
                            >
                              <img
                                class="img-banner"
                                :src="banner.url"
                                :alt="banner.name"
                              />
                            </td>
                            <td>
                              <label v-if="banner.name == null">
                                <small> sin título </small>
                              </label>
                              <label v-else> {{ banner.name }} </label>
                            </td>
                            <!-- <td>{{ banner.sizes != null ? banner.sizes.description : ''}}</td> -->
                            <td>
                              <small v-if="banner.redirection == null">
                                sin redirección
                              </small>
                              <a target="_blank" :href="banner.redirection">{{ banner.redirection }}</a> 
                            </td>
                            <td>
                              <label
                                v-if="banner.status_id == 1"
                                style="color: #dc3545"
                              >
                                {{ banner.status.name }}
                              </label>
                              <label v-else style="color: gray">
                                {{ banner.status.name }}
                              </label>
                            </td>
                            <td>
                              <div class="btn-group" role="group">
                                <div class="btn-group" role="group">
                                  <button
                                    class="btn btn-secondary"
                                    title="Editar"
                                    data-toggle="modal"
                                    data-target="#modalUpdateQuestion"
                                    @click="edit(banner)"
                                  >
                                    Editar
                                  </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <!-- Historial de categorías -->
            <div
              class="tab-pane fade"
              id="nav-categoria"
              role="tabpanel"
              aria-labelledby="nav-categoria-tab"
            >
              <div class="card ">
                <div class="card-body">
                  <template>
                    <div class="table-responsive">
                      <table class="table table-striped table-sm">
                        <caption class="visually-hidden">Listado de Alianzas</caption>
                        <thead>
                          <tr>
                            <th id="ab-5">Nombre categoría</th>
                            <th id="ab-8">Estado</th>
                            <th id="ab-9">Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="cat in categories" v-bind:key="cat.id">
                            <td>
                              {{ cat.name }}
                            </td>
                            <td>
                              <label
                                v-if="cat.status_id == 1"
                                style="color: #dc3545"
                              >
                                Activa
                              </label>
                              <label v-else style="color: gray">
                                Inactiva
                              </label>
                            </td>
                            <td>
                              <div class="btn-group" role="group">
                                <div class="btn-group" role="group">
                                  <button
                                    class="btn btn-secondary"
                                    title="Editar"
                                    data-toggle="modal"
                                    data-target="#modalUpdateCategory"
                                    @click="editCategory(cat)"
                                  >
                                    Editar
                                  </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Nueva Alianza -->
    <div
      class="modal fade"
      id="modalNewBanner"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered border-danger modal-lg">
        <div :class="{ 'is-danger': errorsFile || errorsFile2 }" class="modal-content modal-question">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong>Ingrese una nueva publicación</strong>
                </label><br/>
              </div>
              <div class="form-group col-12">
                <div>
                  <label>Tipo de formulario</label>
                </div><br><br>
                <div class="row text-black-50">
                  <form class="row mb-3">
                      <div style="display:flex; margin:auto;">
                        <div style="padding:0px 50px 0px 50px;" class="form-check">
                          <input class="form-check-input" v-on:change="location = 1" type="radio" name="origin" id="inputRadioAllianceOption">
                          <label class="form-check-label" for="inputRadioAllianceOption">
                            Crear alianza
                          </label>
                        </div>
                        <div style="padding:0px 50px 0px 50px;" class="form-check">
                          <input class="form-check-input" v-on:change="location = 2" type="radio" name="origin" id="inputRadioCategoryOption">
                          <label class="form-check-label" for="inputRadioCategoryOption">
                            Crear categoría alianza
                          </label>
                        </div>
                      </div>
                  </form>
                </div><br>
              </div>
              <div v-if="location == 1" class="form-group">
                <div class="row mb-3 ml-3">
                  <div class="text-black-50">
                    <form ref="form" style="text-align: initial">
                      <label style="color: #616161">
                        <strong>Subir imagen principal de la alianza *</strong>
                      </label>
                      <br>
                      <input
                        type="file"
                        accept="image/*"
                        class="form-control-file mb-2"
                        style="color: black"
                        @change="onfileSelected($event)"
                        :class="{ 'is-danger': errorsFile || errorsFile2 }"
                      />
                    </form>
                  </div>
                  <div class="commentary my-2">
                    <span>
                      RECOMENDACIÓN: solo se permiten imágenes en formato (jpg,jpeg,png).
                    </span><br>
                    <span>
                      El tamaño máximo debe ser de 1MB.
                    </span>
                  </div>
                  <span
                    v-if="errorsFile"
                    class="text-danger float-left small error-danger"
                    >{{ errorsFile }}</span
                  >
                  <span
                    v-if="errorsFile2"
                    class="text-danger float-left small error-danger"
                    >{{ errorsFile2 }}</span
                  >
                </div>
                <div class="col-12">
                  <form ref="form" style="text-align: initial">
                    <label for="image" style="color: #616161; font-size: 14px"
                    ><strong>Subir imagen de detalle de alianza *</strong></label>
                    <input
                      type="file"
                      accept="image/*"
                      id="image"
                      name="image"
                      class="form-control-file mb-2"
                      style="color: black"
                      @change="onfileSelectedDetail($event)"
                      :class="{ 'is-danger': errorsFileDetail || errorsFile2Detail }"
                    />
                  </form>
                  <div class="commentary my-2">
                    <span>
                      RECOMENDACIÓN: solo se permiten imágenes en formato (jpg,jpeg,png).
                    </span><br>
                    <span>
                      El tamaño máximo debe ser de 1MB.
                    </span>
                  </div>
                  <span
                    v-if="errorsFile2Detail"
                    class="text-danger float-left small error-danger"
                    >{{ errorsFile2Detail }}</span
                  >
                </div>
                <br>
                <div class="row mb-3">
                  <div class="col-10" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Nombre Banner Alianzas</strong>
                    </label>
                    <input
                      type="text"
                      v-model="form.nombre"
                      class="form-control"
                      placeholder="Escribe aquí el título del banner"
                    />
                  </div>
                  <span
                    v-if="errorsNameAlliance"
                    class="text-danger float-left small error-danger"
                    >{{ errorsNameAlliance }}</span
                  >
                </div>
                <div class="row mb-3">
                  <div class="col-10" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Redirección detalle de alianza</strong>
                    </label>
                    <input
                      type="url"
                      v-model="form.redirection"
                      class="form-control"
                      placeholder="Escribe aquí la url de redirección"
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-10" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Categoría de la alianza</strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="form.categoryId"
                    >
                      <option value="null" disabled selected
                      >Seleccione una categoría
                      </option>
                      <option v-for="data in categories" :key="data.id" :value="data">
                        {{ data.name }}
                      </option>
                    </select>
                  </div>
                  <span
                    v-if="errorsCategory"
                    class="text-danger float-left small error-danger"
                    ><strong>{{ errorsCategory }}</strong>
                  </span>
                </div>
                <div v-if="form.categoryId != null" class="row mb-3">
                  <div v-if="form.categoryId.id == 3" class="col-10" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Ciudad</strong>
                    </label>
                    <input
                      type="text"
                      v-model="form.city"
                      class="form-control"
                      placeholder="Escribe aquí la ciudad de la alianza"
                    />
                  </div>
                </div>
              </div>

              <div style="min-width:100%;" v-if="location == 2" class="form-group">
                <div class="row mb-3">
                  <div class="col-10" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Nombre Categoría Alianzas</strong>
                    </label>
                    <input
                      type="text"
                      v-model="category.name"
                      class="form-control"
                      placeholder="Escribe aquí el nombre de la categoría"
                    /><br>
                    <span
                      v-if="errorsNameCategory"
                      class="text-danger float-left small error-danger"
                      ><strong>{{ errorsNameCategory }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <!-- Crear alianza -->
              <div v-if="location == 1" class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button
                  @click="createPublication()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Aceptar</template>
                </button>
              </div>
              <!-- Crear categoría -->
              <div v-if="location == 2" class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button
                  @click="createCategory()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Crear categoría</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Editar Alianza -->
    <div
      class="modal fade "
      id="modalUpdateQuestion"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content modal-question ">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong style="font-size:20px">Editar publicación</strong> 
                </label><br><br>
              </div>
              <div class="form-group">
                <div class="row mb-3 ml-3">
                  <div class="text-black-50">
                    <form ref="form" style="text-align: initial">
                      <label style="color: #616161">
                        <strong>Editar imagen principal de la alianza *</strong>
                      </label>
                      <br>
                      <input
                        type="file"
                        accept="image/*"
                        class="form-control-file mb-2"
                        style="color: black"
                        @change="onfileSelected($event)"
                        :class="{ 'is-danger': errorsFile || errorsFile2 }"
                      />
                    </form>
                  </div>
                  <div class="commentary my-2">
                    <span>
                      RECOMENDACIÓN: solo se permiten imágenes en formato (jpg,jpeg,png).
                    </span><br>
                    <span>
                      El tamaño máximo debe ser de 1MB.
                    </span>
                  </div>
                  <span
                    v-if="errorsFile"
                    class="text-danger float-left small error-danger"
                    >{{ errorsFile }}</span
                  >
                  <span
                    v-if="errorsFile2"
                    class="text-danger float-left small error-danger"
                    >{{ errorsFile2 }}</span
                  >
                </div>
                <div class="col-12">
                  <form ref="form" style="text-align: initial">
                    <label for="image" style="color: #616161; font-size: 14px"
                    ><strong>Editar imagen de detalle de alianza *</strong></label>
                    <input
                      type="file"
                      accept="image/*"
                      id="image"
                      name="image"
                      class="form-control-file mb-2"
                      style="color: black"
                      @change="onfileSelectedDetail($event)"
                      :class="{ 'is-danger': errorsFile || errorsFile2 }"
                    />
                  </form>
                  <div class="commentary my-2">
                    <span>
                      RECOMENDACIÓN: solo se permiten imágenes en formato (jpg,jpeg,png).
                    </span><br>
                    <span>
                      El tamaño máximo debe ser de 1MB.
                    </span>
                  </div>
                  <span
                    v-if="errorsFile"
                    class="text-danger float-left small error-danger"
                    >{{ errorsFile }}</span
                  >
                  <span
                    v-if="errorsFile2"
                    class="text-danger float-left small error-danger"
                    >{{ errorsFile2 }}</span
                  >
                </div>

                <div class="row mb-3">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Redirección</strong>
                    </label>
                    <input
                      type="url"
                      v-model="form.redirection"
                      class="form-control"
                      placeholder="Escribe aquí la url de redirección *"
                    />
                  </div>
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Link de WhatsApp</strong>
                    </label>
                    <input
                      type="url"
                      v-model="form.redirection_whatsapp"
                      class="form-control"
                      placeholder="Escribe aquí el link de whatsapp"
                    />
                  </div>

                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                        ><strong>Categoría de la alianza</strong>
                      </label>
                      <select
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.categoryId"
                      >
                        <!-- <option value="null" disabled selected
                        >Seleccione una categoría
                        </option> -->
                        <option v-for="data in categories" :value="data.id" :key="data.id">
                          {{ data.name }}
                        </option>
                      </select>
                  </div>
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Ciudad</strong>
                    </label>
                    <input
                      type="text"
                      v-model="form.city"
                      class="form-control"
                      placeholder="Escribe aquí la ciudad de la alianza"
                    />
                  </div>
                  <div class="col-4" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Estado de publicación:</strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="form.state"
                    >
                      <option value="0" disabled selected>Seleccione</option>
                      <option value="1">Activar</option>
                      <option value="2">Inactivar</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="updatePublication()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Actualizar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Editar Categoría -->
    <div
      class="modal fade "
      id="modalUpdateCategory"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content modal-question ">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong style="font-size:20px">Editar categoría</strong> 
                </label><br><br>
              </div>
              <div style="min-width:100%;" class="form-group">
                <div class="row mb-3">
                  <div class="col-10" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Nombre Categoría Alianzas</strong>
                    </label>
                    <input
                      type="text"
                      v-model="category.name"
                      class="form-control"
                      placeholder="Escribe aquí el nuevo nombre de la categoría"
                    /><br>
                    <span
                      v-if="errorsNameCategory"
                      class="text-danger float-left small error-danger"
                      ><strong>{{ errorsNameCategory }}</strong>
                    </span>
                  </div>
                  <div class="col-4" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Estado de la categoría:</strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="category.status_id"
                    >
                      <option value="0" disabled selected>Seleccione</option>
                      <option value="1">Activar</option>
                      <option value="2">Inactivar</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="updateCategory()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Actualizar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import draggable from "vuedraggable";

export default {
  data() {
    return {
      location: null,
      errorsCategory: false,
      errorsNameCategory: false,
      errorsNameAlliance: false,
      errorsFile: false,
      errorsFileDetail: false,
      errorsFile2: false,
      errorsFile2Detail: false,
      errorsTitle: false,
      errorsStatus: false,
      sizes: [],
      multipleFiles: [],
      multipleFiles1: [],
      banner1: null,
      banner2: null,
      bannerDetail: [],
      bannerEdit: [],
      form: {
        id: 0,
        urlImg: "",
        nombre: "",
        state: 0,
        redirection: "",
        redirection_whatsapp: "",
        categoryId: null,
        city: null,
      },
      currentForm: {},
      file: null,
      type: 7,
      bannerList: [],
      currentList: [],
      loading: {
        publicate: false,
        history: false,
        changeDoc: false,
        order: false
      },
      hidden: {
        btn: false
      },
      history: [],
      sizeName: null,
      defectList: [],
      category:{
        name: null,
        status_id: 1,
      },
      categories: [],
    };
  },
  components: {
    draggable
  },
  methods: {
    validFormCategory(){
      if(this.category.name == null){
        this.errorsNameCategory = "El nombre de la categoría es obligatorio.";
        return false;
      }else{
        this.errorsNameCategory = "";
        return true
      }
    },
    createCategory(){
      let app = this;
      if(app.validFormCategory()){
        app.loading.changeDoc = true;
        axios
        .post("superAdmin/create/category", app.category)
        .then((res) => {
          if(res.data.cod == 0){
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
            app.loading.changeDoc = false;
            $("#modalNewBanner").modal("hide");
            app.getCategories();
          }
        })
        .catch((error) => {
          app.loading.changeDoc = false;
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      }
    },
    editCategory(cat){
      // console.log('cat ', JSON.stringify(cat));
      let app = this;
      app.errorsNameCategory = false;
      app.category.id = cat.id;
      app.category.name = cat.name;
      app.category.status_id = cat.status_id;
      return cat;
    },
    updateCategory(){
      let app = this;
      if(app.validFormCategory()){
        app.loading.changeDoc = true;
        axios
        .post("superAdmin/edit/category", app.category)
        .then((res) => {
          if(res.data.cod == 0){
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
            app.loading.changeDoc = false;
            $("#modalUpdateCategory").modal("hide");
            app.getCategories();
          }
        })
        .catch((error) => {
          app.loading.changeDoc = false;
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      }
    },
    saveOrders() {
      var listOrders = [];
      var cont = 0; // 4 por que hay 3 por defecto
      for (let i = 0; i < this.bannerList.length; i++) {
        listOrders.push({
          id: this.bannerList[i].id,
          order: cont++
        });
      }
      var data = {
        orders: listOrders
      };
      this.loading.order = true;
      axios
        .post("superAdmin/files/banner/setOrders", data)
        .then(res => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
            this.getImg();
            this.hidden.btn = true;
          }
          this.loading.order = false;
        })
        .catch(error => {
          this.loading.order = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    findSizeName(sizeId){
      this.sizeName = this.sizes.find(name => name.id === sizeId);
      if (!this.sizeName)
        this.sizeName = "";
      else
        this.sizeName = this.sizeName.description;
    },
    clean() {
      this.bannerList = this.currentList;
    },
    onfileSelected(event) {
      let app = this;
      let fileSize = event.target.files[0].size;
      let extension = event.target.files[0].name.split(".");
      if (fileSize > 1000000) {
        this.errorsFile = "El archivo no debe superar 1MB";
        return false;
      }
      if (extension[1] != "jpg" && extension[1] != "png" && extension[1] != "jpeg") {
        this.errorsFile2 = " La extensión es inválida. ";
        return false;
      } 
      else {
        this.errorsFile = false;
        this.errorsFile2 = false;
        app.banner1 = event.target.files[0];
        // console.log('app.banner1: ', app.banner1);
      }
    },
    onfileSelectedDetail(event) {
      let app = this;
      let fileSize = event.target.files[0].size;
      let extension = event.target.files[0].name.split(".");
      if (fileSize > 1000000) {
        this.errorsFileDetail = "El archivo no debe superar 1MB";
        return false;
      }
      if (extension[1] != "jpg" && extension[1] != "png" && extension[1] != "jpeg") {
        this.errorsFile2Detail = " La extensión es inválida. ";
        return false;
      } 
      else {
        this.errorsFileDetail = false;
        this.errorsFile2Detail = false;
        app.banner2 = event.target.files[0];
        // console.log('app.banner2: ', app.banner2);
      }
    },
    validform() {
      let app = this;
      if(this.form.nombre.length == 0){
        app.errorsNameAlliance = "El nombre de la alianza es requerido";
        return false;
      } else {
        app.errorsNameAlliance = "";
      }
      if (app.banner1 == null){
        app.errorsFile = "La imagen es requerida";
        return false;
      }
      if (app.banner2 == null){
        app.errorsFileDetail = "La imagen es requerida";
        return false;
      }
      if(app.form.categoryId == null){
        app.errorsCategory = "La categoría es requerida";
        return false;
      }
      if (!app.errorsFile && !app.errorsFileDetail && !app.errorsNameAlliance){
        return true;
      }
      return false;
    },
    validformEdit() {
      let app = this;
      if (!app.form.nombre || !app.form.state) {
        app.errorsTitle = "Al menos un campo es requerido";
      }
      if (!app.errorsFile && !app.errorsTitle && !app.errorsStatus) {
        return true;
      }
      return false;
    },
    createPublication() {
      if (this.validform()) {
        this.saveAlliance();
      }
    },
    updatePublication() {
      this.postUpdate();
    },
    deletePublication() {
      // console.log("Eliminado");
    },
    deleteData(banner) {
      let app = this;
      app.form.id = banner.id;
      // console.log(app.form.id);
    },
    reset(){
      let app = this;
      app.form.nombre = "";
      app.form.state = 0;
      app.errorsFile = false;
      app.errorsTitle = false;
      app.errorsStatus = false;
      app.errorsFile2 = false;
      this.$refs.form.reset();
      setTimeout(() => {
        this.errorsTitle = false;
        this.errorsFile = false;
      }, 0);
    },
    edit(banner){
      this.currentForm.nombre = banner.name;
      this.currentForm.state = banner.status_id;
      let app = this;
      app.errorsFile = false;
      app.errorsFileDetail = false;
      app.errorsTitle = false;
      app.errorsStatus = false;
      app.errorsFile2 = false;
      app.errorsFile2Detail = false;
      app.file = {};
      app.form.id = banner.id;
      app.form.nombre = banner.name;
      app.form.state = banner.status_id;
      app.form.redirection = banner.redirection;
      app.form.redirection_whatsapp = banner.redirection_whatsapp;
      app.form.categoryId = banner.category_id;
      app.form.city = banner.city;
      // console.log('banner: ', JSON.stringify(banner));
      return banner;
    },
    saveAlliance(){
      const formData = new FormData();
      // console.log('this.banner1 ', this.banner1);
      if(this.banner1 != ""){
        formData.append("file", this.banner1);
        formData.append("size", 5);
      }
      formData.append("name", this.form.nombre);
      formData.append("type", this.type);
      formData.append("redirection", this.form.redirection);
      formData.append("redirection_whatsapp", this.form.redirection_whatsapp);
      formData.append("category_id", this.form.categoryId.id);
      formData.append("city", this.form.city);
      this.loading.changeDoc = true;
      axios
        .post("admin/file/uploadAlliances", formData)
        .then(res => {
          if (res.data.cod == 0) {

            const formData1 = new FormData();
            // console.log('this.banner2 ', this.banner2);
            if(this.banner2 != ""){
              formData1.append("file", this.banner2);
              formData1.append("size", 5);
            }
            formData1.append("name", this.form.nombre);
            formData1.append("description", 1);
            formData1.append("type", this.type);
            formData1.append("redirection", this.form.redirection);
            formData1.append("redirection_whatsapp", this.form.redirection_whatsapp);
            formData1.append("category_id", this.form.categoryId.id);
            formData1.append("city", this.form.city);
            this.saveAlliance2(formData1);
          }
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    saveAlliance2(formData1) {
      axios
        .post("admin/file/uploadAlliances", formData1)
        .then(res => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
            this.loading.changeDoc = false;
            $("#modalNewBanner").modal("hide");
            this.getImg();
            // setTimeout(() => {
            //   window.location.reload();
            // }, 3000);
          }
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    getRequets() {
      axios
        .get("url")
        .then(res => {
          // console.log(res.data.data);
          if (res.data.cod == 0) {
            this.data = res.data.data;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    postUpdate() {
      // console.log('this.form: ', JSON.stringify(this.form));
      const formData = new FormData();
      formData.append("id", this.form.id);
      if (this.currentForm.state != this.form.state) {
        formData.append("statusId", this.form.state);
      }
      formData.append("name", this.form.nombre);
      formData.append("redirection", this.form.redirection);
      formData.append("redirection_whatsapp", this.form.redirection_whatsapp);
      if (this.banner1 != null) {
        formData.append("file", this.banner1);
      }
      formData.append("description", 2);
      formData.append("size", 5);
      formData.append("type", this.type);
      formData.append("category_id", this.form.categoryId);
      formData.append("city", this.form.city);
      this.loading.changeDoc = true;
      axios
        .post("superAdmin/files/alliance/edit", formData)
        .then(res => {
          if (res.data.cod == 0) {

            const formData1 = new FormData();
            formData1.append("id", this.form.id);
            if (this.currentForm.state != this.form.state) {
              formData1.append("statusId", this.form.state);
            }
            formData1.append("name", this.form.nombre);
            formData1.append("redirection", this.form.redirection);
            formData1.append("redirection_whatsapp", this.form.redirection_whatsapp);
            if (this.banner2 != null) {
              formData1.append("file", this.banner2);
            }
            formData1.append("description", 1);
            formData1.append("size", 5);
            formData1.append("type", this.type);
            formData1.append("category_id", this.form.categoryId);
            formData1.append("city", this.form.city);
            this.postUpdate2(formData1);
          }
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    postUpdate2(formData1) {
      axios
        .post("superAdmin/files/alliance/edit", formData1)
        .then(res => {
          if (res.data.cod == 0) {
            $("#modalUpdateQuestion").modal("hide");
            this.getImg();
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
          this.loading.changeDoc = false;
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    delete() {
      axios
        .delete("url", this.form)
        .then(res => {
          // console.log(res.data.data);
          if (res.data.cod == 0) {
            this.$swal(res.data.message, "", "success");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getImg() {
      this.defectList = [];
      this.bannerList = [];
      this.currentList = [];
      this.history = [];
      this.loading.history = true;
      axios
        .get("superAdmin/files/histories/7")
        .then(res => {
          if (res.data.cod == 0) {
            var list = res.data.data;
            for (let i = 0; i < list.length; i++) {
              // if (
              //   list[i].order == 1 ||
              //   list[i].order == 2 ||
              //   list[i].order == 3
              // ) {
              //   this.defectList.push(list[i]);
              // } 
              // else {
                if (list[i].status_id == 1 && list[i].size == 5 && list[i].description == null) {
                  this.bannerList.push(list[i]);
                  this.currentList.push(list[i]);
                }
              // }
              this.history = res.data.data;
            }
          }
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    getImagesSizes() {
      this.loading.history = true;
      axios
      .get("admin/file/get/imageSize")
      .then(res => {
        this.sizes = res.data.data;
        this.loading.history = false;
      })
      .catch(error => {
        this.loading.history = false;
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
    getCategories(){
      axios
      .get("superAdmin/get/categories")
      .then(res => {
        this.categories = res.data.data;
        // console.log(JSON.stringify(this.categories));
      })
      .catch(error => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
  },
  mounted(){
    this.getImg();
    this.getImagesSizes();
    this.getCategories();
  },
  watch: {
    bannerList: function(newL) {
      var cont = 0;
      for (let i = 0; i < this.currentList.length; i++) {
        if (this.currentList[i].id != newL[i].id) {
          cont++;
        }
      }
      if (cont > 0) {
        this.hidden.btn = false;
      } else {
        this.hidden.btn = true;
      }
    }
  }
};
</script>

<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.div-button {
  margin-top: 50px;
  text-align: left;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.modal-title {
  color: black;
  font-weight: bold;
}
.modal-question {
  border: solid 3px;
  /* border-color: #dc3545; */
  border-radius: 15px;
}
label {
  color: black;
  margin-right: 4px;
}
.img-banner {
  display: block;
  width: 25%;
  text-align: center;
  margin: auto;
}
td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}
.table-container {
  overflow: auto;
}
h5 {
  margin-bottom: 10px !important;
}
.commentary {
  text-align: left;
  color: #1da5df;
  font-size: 13px;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
